function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M72.1644 22.0203C70.8634 22.4072 69.3587 22.6007 67.6502 22.6007C65.7849 22.6007 64.1548 22.2602 62.7598 21.5791C61.3648 20.8826 60.2754 19.9152 59.4917 18.6769C58.7236 17.4386 58.3396 15.9836 58.3396 14.312C58.3396 12.6248 58.7315 11.1621 59.5152 9.9238C60.2989 8.68552 61.4118 7.73359 62.8538 7.06802C64.2959 6.38696 65.9965 6.04644 67.9558 6.04644C68.4104 6.04644 68.9355 6.08513 69.5311 6.16252C70.1424 6.23992 70.6205 6.33279 70.9653 6.44114V9.34336C70.5264 9.23501 70.0405 9.15762 69.5076 9.11118C68.9747 9.04927 68.4574 9.01831 67.9558 9.01831C66.6549 9.01831 65.5263 9.23501 64.5702 9.66841C63.614 10.1018 62.8773 10.7132 62.3601 11.5026C61.8428 12.292 61.5842 13.2285 61.5842 14.312C61.5842 15.9991 62.125 17.3303 63.2065 18.3054C64.3037 19.2806 65.7849 19.7681 67.6502 19.7681C68.1361 19.7681 68.5985 19.7372 69.0374 19.6753V13.1279H72.1644V22.0203Z",
  fill: "#DD3857"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M81.97 6H82.2051L90.5988 22.3453H87.0955L85.8259 19.7217H78.3492L77.0091 22.3453H73.5764L81.97 6ZM84.4387 16.9124L82.0876 12.0831L79.7364 16.9124H84.4387Z",
  fill: "#DD3857"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M92.3709 6.32505H98.7661C100.49 6.32505 101.815 6.71201 102.74 7.48594C103.68 8.24438 104.15 9.32014 104.15 10.7132C104.15 12.5552 103.296 13.9947 101.587 15.0317L104.715 22.3453H101.282L98.8131 16.1229L95.498 17.1213V22.3453H92.3709V6.32505ZM97.614 13.6386C98.821 13.3136 99.6674 12.9421 100.153 12.5242C100.655 12.1063 100.906 11.5413 100.906 10.8293C100.906 10.303 100.694 9.89285 100.271 9.59875C99.8476 9.30466 99.252 9.15762 98.484 9.15762H95.498V14.1959L97.614 13.6386Z",
  fill: "#DD3857"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M113.701 6H113.937L122.33 22.3453H118.827L117.557 19.7217H110.081L108.741 22.3453H105.308L113.701 6ZM116.17 16.9124L113.819 12.0831L111.468 16.9124H116.17Z",
  fill: "#DD3857"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M136.362 22.0203C135.061 22.4072 133.556 22.6007 131.848 22.6007C129.983 22.6007 128.352 22.2602 126.957 21.5791C125.562 20.8826 124.473 19.9152 123.689 18.6769C122.921 17.4386 122.537 15.9836 122.537 14.312C122.537 12.6248 122.929 11.1621 123.713 9.9238C124.497 8.68552 125.609 7.73359 127.051 7.06802C128.493 6.38696 130.194 6.04644 132.153 6.04644C132.608 6.04644 133.133 6.08513 133.729 6.16252C134.34 6.23992 134.818 6.33279 135.163 6.44114V9.34336C134.724 9.23501 134.238 9.15762 133.705 9.11118C133.172 9.04927 132.655 9.01831 132.153 9.01831C130.852 9.01831 129.724 9.23501 128.768 9.66841C127.812 10.1018 127.075 10.7132 126.558 11.5026C126.04 12.292 125.782 13.2285 125.782 14.312C125.782 15.9991 126.323 17.3303 127.404 18.3054C128.501 19.2806 129.983 19.7681 131.848 19.7681C132.334 19.7681 132.796 19.7372 133.235 19.6753V13.1279H136.362V22.0203Z",
  fill: "#DD3857"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M139.302 6.32505H149.906V9.20405H142.429V12.0831H146.896V14.9621H142.429V19.4663H150V22.3453H139.302V6.32505Z",
  fill: "#DD3857"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M58.3226 43.6425C58.7197 43.7405 59.1913 43.8222 59.7372 43.8875C60.2832 43.9529 60.763 43.9856 61.1767 43.9856C62.0039 43.9856 62.6492 43.8303 63.1125 43.5199C63.5923 43.1931 63.8322 42.7357 63.8322 42.1475C63.8322 41.6737 63.6833 41.2407 63.3855 40.8486C63.0876 40.4565 62.5913 40.0317 61.8964 39.5742L60.73 38.7899C59.7703 38.1527 59.0754 37.491 58.6453 36.8048C58.2151 36.1023 58 35.318 58 34.4521C58 32.998 58.546 31.8624 59.638 31.0455C60.7465 30.2123 62.2604 29.7956 64.1796 29.7956C64.5105 29.7956 64.8745 29.8201 65.2716 29.8692C65.6687 29.9018 65.95 29.9345 66.1154 29.9672V32.9816C65.8838 32.9326 65.586 32.8918 65.222 32.8591C64.8745 32.8264 64.5105 32.8101 64.13 32.8101C63.3193 32.8101 62.6823 32.9571 62.219 33.2512C61.7723 33.529 61.5489 33.9048 61.5489 34.3786C61.5489 34.7543 61.6648 35.0893 61.8964 35.3834C62.1446 35.6611 62.5996 36.0206 63.2614 36.4617L64.4278 37.246C66.3967 38.5694 67.3811 40.1869 67.3811 42.0985C67.3811 43.6179 66.8434 44.8188 65.768 45.7011C64.6925 46.567 63.22 47 61.3504 47C60.854 47 60.3081 46.9673 59.7124 46.902C59.1333 46.8366 58.6701 46.7549 58.3226 46.6569V43.6425Z",
  fill: "#DD3857"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M72.9314 32.9816H68.1664V29.9427H80.9971V32.9816H76.2321V46.853H72.9314V32.9816Z",
  fill: "#DD3857"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M83.3407 29.9427H90.0911C91.9111 29.9427 93.3092 30.3511 94.2853 31.1681C95.278 31.9686 95.7744 33.1042 95.7744 34.5746C95.7744 36.5189 94.8727 38.0384 93.0692 39.133L96.37 46.853H92.7466L90.1407 40.2849L86.6414 41.3387V46.853H83.3407V29.9427ZM88.875 37.6626C90.149 37.3195 91.0425 36.9274 91.5554 36.4862C92.0848 36.0451 92.3495 35.4487 92.3495 34.6972C92.3495 34.1417 92.1262 33.7087 91.6795 33.3983C91.2327 33.0878 90.604 32.9326 89.7933 32.9326H86.6414V38.2508L88.875 37.6626Z",
  fill: "#DD3857"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M98.6094 29.9427H109.802V32.9816H101.91V36.0206H106.626V39.0595H101.91V43.814H109.902V46.853H98.6094V29.9427Z",
  fill: "#DD3857"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M119.937 29.5996H120.186L129.046 46.853H125.348L124.007 44.0836H116.115L114.701 46.853H111.077L119.937 29.5996ZM122.543 41.1182L120.061 36.0206L117.58 41.1182H122.543Z",
  fill: "#DD3857"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M130.916 29.6241H131.164L139.28 36.0941L147.221 29.6241H147.47V46.853H144.169V36.0451L139.255 40.1379H139.156L134.217 36.0206V46.853H130.916V29.6241Z",
  fill: "#DD3857"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.61111 16.1697C2.61111 13.0702 5.23231 11.761 5.25866 11.748L19.9585 3.56096C19.9585 3.56096 21.1795 2.6459 23.4424 2.6459C25.7054 2.6459 27.0415 3.56096 27.0415 3.56096L41.7414 11.7479C41.7414 11.7479 44.3889 13.3493 44.3889 16.1697V42.5305C44.3889 46.2991 41.2195 49.3541 37.3099 49.3541H9.69012C5.78049 49.3541 2.61111 46.2991 2.61111 42.5305V16.1697ZM42.411 10.6114C43.0801 9.47616 43.0808 9.47657 43.0815 9.47699L43.0832 9.47808L43.087 9.48038L43.0954 9.48547L43.115 9.49763C43.1295 9.50661 43.1465 9.51735 43.166 9.52985C43.2051 9.55483 43.254 9.58693 43.3116 9.6261C43.4263 9.70423 43.5767 9.81163 43.7509 9.9479C44.0956 10.2176 44.5529 10.6157 45.0148 11.1412C45.9214 12.1724 47 13.8791 47 16.1697V42.5305C47 47.8834 42.5371 52 37.3099 52H9.69012C4.46291 52 0 47.8834 0 42.5305V16.1697C0 13.778 1.03701 12.0552 2.02935 10.9818C2.51858 10.4525 3.00529 10.069 3.37611 9.81329C3.56326 9.68423 3.72606 9.58417 3.85213 9.51136C3.91534 9.47485 3.96981 9.44491 4.01408 9.42133C4.02167 9.41728 4.02896 9.41342 4.03596 9.40975L18.5981 1.29946C18.6787 1.24639 18.7795 1.18348 18.9001 1.11441C19.1518 0.970299 19.4914 0.798468 19.9161 0.633279C20.7691 0.301478 21.9567 0 23.4424 0C24.925 0 26.1291 0.300194 26.9879 0.618694C27.4169 0.777781 27.7615 0.942003 28.0149 1.07733C28.1417 1.14509 28.2463 1.20593 28.3279 1.25575C28.3422 1.26447 28.3557 1.27287 28.3686 1.2809L43.0398 9.4518L43.0797 9.47595L42.411 10.6114C42.411 10.6114 42.411 10.6114 42.411 10.6114Z",
  fill: "url(#paint0_radial_456_1772)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M36.6839 25.6975C38.4387 26.72 38.4387 29.28 36.6839 30.3025L18.9424 40.6408C17.1896 41.6623 15 40.3835 15 38.3383L15 17.6617C15 15.6165 17.1896 14.3377 18.9424 15.3592L36.6839 25.6975Z",
  fill: "url(#paint2_radial_456_1772)"
});

var _ref16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_456_1772",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(2.61111 2.64567) rotate(48.1894) scale(62.6663 51.2674)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0760668
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.578125,
  stopColor: "#FF0000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_angular_456_1772",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(2.61111 49.3541) rotate(90) scale(146.862 131.359)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.046875,
  stopColor: "#FF0000",
  stopOpacity: 0.72
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.244792
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.421875,
  stopColor: "#FF0000",
  stopOpacity: 0.72
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.671875,
  stopColor: "#FF0000",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.802083,
  stopColor: "#FF0000",
  stopOpacity: 0.72
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.892984
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_456_1772",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(40.6354 10.7509) rotate(134.735) scale(48.5636 39.9757)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0760668
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.578125,
  stopColor: "#D80303"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_angular_456_1772",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.45501 10.7509) rotate(-180) scale(107.471 108.47)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.046875,
  stopColor: "#FF0000",
  stopOpacity: 0.72
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.244792
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.421875,
  stopColor: "#FF0000",
  stopOpacity: 0.72
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.671875,
  stopColor: "#FF0000",
  stopOpacity: 0.49
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.802083,
  stopColor: "#FF0000",
  stopOpacity: 0.72
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.892984
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 52,
    viewBox: "0 0 150 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.61111 16.1697C2.61111 13.0702 5.23231 11.761 5.25866 11.748L19.9585 3.56096C19.9585 3.56096 21.1795 2.6459 23.4424 2.6459C25.7054 2.6459 27.0415 3.56096 27.0415 3.56096L41.7414 11.7479C41.7414 11.7479 44.3889 13.3493 44.3889 16.1697V42.5305C44.3889 46.2991 41.2195 49.3541 37.3099 49.3541H9.69012C5.78049 49.3541 2.61111 46.2991 2.61111 42.5305V16.1697ZM42.411 10.6114C43.0801 9.47616 43.0808 9.47657 43.0815 9.47699L43.0832 9.47808L43.087 9.48038L43.0954 9.48547L43.115 9.49763C43.1295 9.50661 43.1465 9.51735 43.166 9.52985C43.2051 9.55483 43.254 9.58693 43.3116 9.6261C43.4263 9.70423 43.5767 9.81163 43.7509 9.9479C44.0956 10.2176 44.5529 10.6157 45.0148 11.1412C45.9214 12.1724 47 13.8791 47 16.1697V42.5305C47 47.8834 42.5371 52 37.3099 52H9.69012C4.46291 52 0 47.8834 0 42.5305V16.1697C0 13.778 1.03701 12.0552 2.02935 10.9818C2.51858 10.4525 3.00529 10.069 3.37611 9.81329C3.56326 9.68423 3.72606 9.58417 3.85213 9.51136C3.91534 9.47485 3.96981 9.44491 4.01408 9.42133C4.02167 9.41728 4.02896 9.41342 4.03596 9.40975L18.5981 1.29946C18.6787 1.24639 18.7795 1.18348 18.9001 1.11441C19.1518 0.970299 19.4914 0.798468 19.9161 0.633279C20.7691 0.301478 21.9567 0 23.4424 0C24.925 0 26.1291 0.300194 26.9879 0.618694C27.4169 0.777781 27.7615 0.942003 28.0149 1.07733C28.1417 1.14509 28.2463 1.20593 28.3279 1.25575C28.3422 1.26447 28.3557 1.27287 28.3686 1.2809L43.0398 9.4518L43.0797 9.47595L42.411 10.6114C42.411 10.6114 42.411 10.6114 42.411 10.6114Z",
    fill: "url(#paint1_angular_456_1772)",
    style: {
      mixBlendMode: "screen"
    }
  }), _ref15, /*#__PURE__*/React.createElement("path", {
    d: "M36.6839 25.6975C38.4387 26.72 38.4387 29.28 36.6839 30.3025L18.9424 40.6408C17.1896 41.6623 15 40.3835 15 38.3383L15 17.6617C15 15.6165 17.1896 14.3377 18.9424 15.3592L36.6839 25.6975Z",
    fill: "url(#paint3_angular_456_1772)",
    style: {
      mixBlendMode: "screen"
    }
  }), _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.c0004917.svg";
export { ForwardRef as ReactComponent };